import { z } from "zod";

import { defaultItem, defaultUrl, transformerMdContentParam, itemSchema, urlSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const educationSchema = itemSchema.extend({
  institution: z.string().min(1),
  studyType: z.string(),
  area: z.string(),
  score: z.string(),
  date: z.string(),
  summary: transformerMdContentParam,
  url: urlSchema,
});

export const minimalEducationSchema = educationSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Education = z.infer<typeof educationSchema>;
export type MinimalEducation = z.infer<typeof minimalEducationSchema>;

// Defaults
export const defaultEducation: Education = {
  ...defaultItem,
  id: "",
  institution: "",
  studyType: "",
  area: "",
  score: "",
  date: "",
  summary: "",
  url: defaultUrl,
};

export const deminimalizeEducation = (education: MinimalEducation): Education => {
  return {
    ...defaultEducation,
    ...education,
    id: createId(),
  };
};
